import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full md:w-1/2 h-full flex flex-col" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Projekte")
const _hoisted_3 = ["onClick"]

import { useCompany } from '@/store/company';
import { 
  IonContent,
  IonIcon, 
  IonLabel,
  IonList,
  IonItem,
  IonInfiniteScroll, 
  IonInfiniteScrollContent,
  IonRefresher,
  IonRefresherContent,
} from '@ionic/vue';
import { chevronForward } from 'ionicons/icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectList',
  props: {
    projects: null
  },
  emits: ["loadProjects", "searchProject", "openPage"],
  setup(__props: any, { emit }: { emit: ({
  (event: "loadProjects", value: any): Promise<any>,
  (event: "searchProject", value: boolean): Promise<any>,
  (event: "openPage", value: string): void,
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  projects: any[]
}

const companyStore = useCompany()






async function refreshPage(event: any) {
  await emit("searchProject", true)
  await event.target.complete()
}

async function loadProjects(event: any) {
  await emit("loadProjects", event)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(IonLabel), { class: "w-full text-center text-2xl pb-4 md:block hidden" }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_unref(IonContent), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonRefresher), {
          slot: "fixed",
          onIonRefresh: _cache[0] || (_cache[0] = ($event: any) => (refreshPage($event)))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonRefresherContent))
          ]),
          _: 1
        }),
        _createVNode(_unref(IonList), null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.projects, (project, index) => {
              return (_openBlock(), _createBlock(_unref(IonItem), {
                id: 'projectListItem' + index,
                key: index
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    onClick: ($event: any) => (_ctx.$router.push('/detail/' + project._id + '/data')),
                    class: "w-full min-h-12 flex items-center justify-between"
                  }, [
                    _createVNode(_unref(IonLabel), { class: "flex-grow text-sm sm:text-base font-bold" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(project.name), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_unref(IonIcon), {
                      icon: _unref(chevronForward),
                      style: _normalizeStyle('color: ' + _unref(companyStore).activeCompany.color),
                      class: "h-8 min-w-8 flex items-center justify-center active:scale-90 duration-200"
                    }, null, 8, ["icon", "style"])
                  ], 8, _hoisted_3)
                ]),
                _: 2
              }, 1032, ["id"]))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_unref(IonInfiniteScroll), {
          onIonInfinite: _cache[1] || (_cache[1] = ($event: any) => (loadProjects($event))),
          id: "infinite-scroll",
          class: "mt-3",
          threshold: "100px",
          disabled: false
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonInfiniteScrollContent), {
              "loading-spinner": "circular",
              "loading-text": "Lade weitere Daten..."
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})